import Footer from '../Components/Footer';
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Disclaimer from '../Components/Disclaimer';
import PersonalInfo from "../Components/PersonalInfo";
import MedicalInsuranceInformation from "../Components/MedicalInsuranceInformation";
import { registrationType } from '../Constants/RegistrationType';
import DateHelpers from '../Helper/DateHelpers'
import DataAccessHelper from '../Helper/DataAccessHelper';
import CamperTypeSelection from '../Components/CamperTypeSelection';
import JoinGroup from '../Components/JoinGroup';
import IndividualRegistrationReview from '../Components/IndividualRegistrationReview';
import IndividualRegistrationPayment from '../Components/IndividualRegistrationPayment';
import InputValidation from '../Helper/InputValidation';
import '../Styles/IndividualRegistration.scss';
import CampEventAndDateSelection from '../Components/CampEventAndDateSelection';
import { CombinationPageOptions } from '../Constants/RegistrationPageOptions';
import { YouthCampMinAge } from "../Constants/EventCamperAges"
import { YouthCampMaxAge } from "../Constants/EventCamperAges"
import { useCart } from '../Contexts/CartContext';

function IndividualRegistration() {


   const navigate = useNavigate();
   const { refreshCount } = useCart();
   const [account, setAccount] = useState();
   const [eventAndDate, setEventAndDate] = useState({ groupCode: '' })
   const [signatureData, setSignatureData] = useState({ signature: '', signatureDate: null })
   const [selectedPage, setSelectedPage] = useState(CombinationPageOptions.WeekSelection)
   const [week, setWeek] = useState();
   const [accountId, setAccountId] = useState();
   const [campEvent, setCampEvent] = useState('Select Camp Type');
   const [groupJoined, setGroupJoined] = useState();
   const [isInGroup, setIsInGroup] = useState(false);
   const [reservationInfo, setReservationInfo] = useState();
   const [isSignatureRequired, setIsSignatureRequired] = useState(false);
   const [promoCode, setPromoCode] = useState({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, discountAmount: 0, promoId: null });
   const [camperType, setCamperType] = useState('Select Camper Type');
   const [groupCode, setGroupCode] = useState('');
   const [buddyName, setBuddyName] = useState('');
   const [buddyBirthDate, setBuddyBirthDate] = useState('');
   const [currentRegistrant, setCurrentRegistrant] = useState();
   const [amountDue, setAmountDue] = useState(0.00);
   const [paymentAmount, setPaymentAmount] = useState(0.00);
   const [paymentType, setPaymentType] = useState('');
   // Set alongside amountDue once Stripe confirms, so the effect-triggered ProcessRegistration can
   // record which charge paid for the registration.
   const [paymentIntentId, setPaymentIntentId] = useState(null);

   const [personalInformation, setPersonalInformation] = useState({
      firstName: '',
      lastName: '',
      gender: '',
      strAddress: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      ecName: '',
      ecRelationship: '',
      ecPhone: '',
      birthDate: ''
   })
   const [medicalInformation, setMedicalInformation] = useState({
      insuranceCompany: '',
      insuranceId: '',
      groupPolicyNumber: '',
      policyHolderName: '',
      policyHolderBirthdate: null,
      hasDiabetes: 'off',
      hasHeartCondition: 'off',
      hasEpilepsy: 'off',
      hasEnvironmentAllergies: 'off',
      hasHeatExhaustion: 'off',
      hasThyroidProblem: 'off',
      hasLupus: 'off',
      hasHighBloodPressure: 'off',
      hasAsthma: 'off',
      drugAllergies: '',
      emergencyAction1: '',
      foodAllergies: '',
      emergencyAction2: '',
      allergicReactions: '',
      otherAllergies: '',
      emergencyAction3: '',
      medicationName: '',
      medicationDose: '',
      tetanusShotDate: null
   })

   let eventRegistrationType = registrationType.Combination
   let campMinAge = YouthCampMinAge;
   let campMaxAge = YouthCampMaxAge;

   async function setAccountIdForCurrentGuest() {
      const accountIdResponse = await DataAccessHelper.getCurrentAccountInformation()
      setAccountId(accountIdResponse.account.account_id)
      setAccount(accountIdResponse.account)
      console.log('account Id response', accountIdResponse.account.account_id)
   }

   async function validateAndProcessRegistration(paymentIntentId) {
      console.log(paymentIntentId, "Payment intent id in the validate and process reservation function")
      try {
         const response = await fetch('/api/verify-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paymentIntentId }),
         });

         if (!response.ok) {
            console.error('Server returned an error verifying payment intent');
            return false
         }

         const data = await response.json();
            console.log("data", data)
         if (data.result.status === 'succeeded') {
            console.log("data", data)
            // Payment returned, set the amount due, payment amount
            var pricePaid = InputValidation.shiftDecimalLeft(data.result.amount, 2)
            console.log("pricePaid", pricePaid)
            var eventPrice = Number(week.camp_fee) + Number(week.registration_fee)
            console.log("event price", eventPrice)
            var effectivePrice = eventPrice
            if (promoCode.isSelected && promoCode.discountPercent > 0 && promoCode.discountPercent < 100) {
               effectivePrice = eventPrice * (1 - promoCode.discountPercent / 100)
            } else if (promoCode.isSelected && promoCode.discountAmount > 0) {
               effectivePrice = Math.max(0, eventPrice - promoCode.discountAmount)
            }
            const amountDue = (effectivePrice - pricePaid).toFixed(2);
            setPaymentIntentId(paymentIntentId)
            setAmountDue(amountDue)

            return true
         } else {
            console.warn('Payment not confirmed. Status:', data.result.status);
            return false
         }
      } catch (err) {
         console.error('Error validating payment intent:', err);
      }
   }

   // Puts the finished registration in the cart instead of collecting payment here. The payload is
   // the same body /individualregistration has always taken, stored verbatim and replayed at
   // checkout, so nothing about the registration itself changes — only when it gets paid for.
   async function AddToCart() {
      try {
         const response = await fetch('/cart/add', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               flow: 'individual',
               payload: {
                  accountId: account.account_id,
                  camperType,
                  groupJoined,
                  week,
                  // The disclaimer was signed now, so this is the date that belongs on the
                  // registration — not whenever payment happens to land.
                  signatureData: {
                     ...signatureData,
                     signatureDate: signatureData.signatureDate ?? new Date().toISOString(),
                  },
                  reservationInfo,
                  eventRegistrationType,
                  isInGroup,
                  personalInformation,
                  medicalInformation,
               },
            })
         })

         const data = await response.json()
         if (!response.ok) {
            return data.error ?? 'Could not add this registration to your cart.'
         }

         refreshCount()
         navigate('/mycart')
         return ''
      } catch (error) {
         console.log(error)
         return 'Could not add this registration to your cart.'
      }
   }

   async function ProcessRegistration() {
      var registrationResult = await AddRegistration()

      console.log("Payment amount", paymentAmount)
      // Written even at $0 so every registration has a row in the ledger.
      if (registrationResult) {
         await AddTransaction(registrationResult)
      }
      navigate('/daycamppaymentsuccess', { state: { paymentAmount, promoCode } })
   }

   // CHECK THIS!!
   async function AddRegistration() {
      let accountId = account.account_id;
      console.log("Is In Group", isInGroup)
      console.log("Reservation Info in Add Registration method", reservationInfo)
      try {
         console.log("amount due", amountDue)
         var registrationRequest = await fetch('/individualregistration', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               accountId,
               camperType,
               groupJoined,
               promoCode,
               week,
               signatureData,
               reservationInfo,
               amountDue,
               paymentAmount,
               eventRegistrationType,
               isInGroup,
               personalInformation,
               medicalInformation,
            })
         })

         let registrationResult = await registrationRequest.json();
         // This read used to be data.individualRegistration[0].registration_id — the wrong key and
         // the wrong column — so it threw and AddTransaction below never ran, leaving individual
         // registrations with no transaction row at all.
         return registrationResult.data.Registration[0].regist_id

      } catch (error) {
         console.log(error)
      }
   }

   async function AddTransaction(registrationId) {
      try {
         const transaction = await fetch('/addtransaction', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionValue: paymentAmount,
               // Sent as reservationId before, which filed the payment against reservation_id
               // instead of the registration it actually belonged to.
               registId: registrationId,
               paymentType: paymentType,
               paymentIntentId
            })
         })
         let transactionResult = await transaction.json();
      } catch (error) {
         console.log("Exception", error)
      }
   }

   async function getAccountInformation(accountId) {
      try {
         var individualRequest = await fetch('/getindividual', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               accountId
            })
         })

         if (!individualRequest.ok) {
            throw new Error(`HTTP error! Status: ${individualRequest.status}`);
         }

         let individualResponse = await individualRequest.json();
         console.log("Here is Individual Response\n\n", individualResponse)
         // Validating Data Structure 
         if (!individualResponse?.data?.eventInfo?.length) {
            console.error("Missing eventInfo data");
            return null; // Prevents errors from undefined access
         }
         setCurrentRegistrant(() => individualResponse.data.eventInfo[0])

      } catch (error) {
         console.error("Missing eventInfo data");
         return null;
      }
   }

   useEffect(() => {
      setAccountIdForCurrentGuest()
   }, []);

   useEffect(() => {
      console.log("Actually, here is the guest id!", accountId)
      getAccountInformation(accountId)
   }, [accountId])


   useEffect(() => {
  if (amountDue == null) return; // only skip if null or undefined
  ProcessRegistration();
}, [amountDue]);


   return (
      <div className="individualRegistrationContainer">
         {selectedPage === CombinationPageOptions.WeekSelection &&
            <CampEventAndDateSelection
               eventRegistrationType={eventRegistrationType}
               campEventSelection={campEvent} setCampEventSelection={w => setCampEvent(w)}
               weekSelection={week} setWeekSelection={w => setWeek(w)}
               eventAndDate={eventAndDate} setEventAndDate={setEventAndDate}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               setPromoCode={setPromoCode} />
         }
         {selectedPage === CombinationPageOptions.PersonalInfo &&
            <PersonalInfo
               personalInformation={personalInformation}
               setPersonalInformation={setPersonalInformation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               previousPage={CombinationPageOptions.WeekSelection}
               nextPage={CombinationPageOptions.MedicalInsurance} />
         }
         {selectedPage === CombinationPageOptions.MedicalInsurance &&
            <MedicalInsuranceInformation
               medicalInformation={medicalInformation}
               setMedicalInformation={setMedicalInformation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               previousPage={CombinationPageOptions.PersonalInfo}
               nextPage={CombinationPageOptions.JoinGroup}
            />
         }

         {selectedPage === CombinationPageOptions.JoinGroup &&
               <JoinGroup
                  groupJoin={groupJoined}
                  setGroupJoined={setGroupJoined}
                  setIsInGroup={setIsInGroup}
                  week={week}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  reservationInfo={reservationInfo}
                  setReservationInfo={setReservationInfo}
                  setPromoCode={setPromoCode}
               />
         }
         {selectedPage === CombinationPageOptions.CamperType &&
               <CamperTypeSelection
                  camperType={camperType}
                  setCamperType={setCamperType}
                  groupJoined={groupJoined}
                  week={week}
                  promoCode={promoCode}
                  setPromoCode={setPromoCode}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  accountId={accountId}
                  isSignatureRequired={isSignatureRequired}
                  setIsSignatureRequired={setIsSignatureRequired}
                  personalInformation={personalInformation}
                  currentRegistrant={currentRegistrant} />
         }
         {selectedPage === CombinationPageOptions.Disclaimer &&
               <Disclaimer
                  accountId={accountId}
                  setAccountId={setAccountId}
                  camperType={camperType}
                  setCamperType={setCamperType}
                  groupJoined={groupJoined}
                  week={week}
                  promoCode={promoCode}
                  setPromoCode={setPromoCode}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  signatureData={signatureData}
                  setSignatureData={setSignatureData} />
         }
         {selectedPage === CombinationPageOptions.Review &&
               <IndividualRegistrationReview
                  accountId={accountId}
                  amountDue={amountDue}
                  setAmountDue={setAmountDue}
                  camperType={camperType}
                  setCamperType={setCamperType}
                  groupJoined={groupJoined}
                  setGroupJoined={setGroupJoined}
                  week={week}
                  promoCode={promoCode}
                  ProcessRegistration={ProcessRegistration}
                  AddToCart={AddToCart}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  signatureData={signatureData}
                  setSignatureData={setSignatureData}
                  isSignatureRequired={isSignatureRequired}
                  currentRegistrant={currentRegistrant} />
         }
         {selectedPage === CombinationPageOptions.Payment &&
               <IndividualRegistrationPayment
                  account={account}
                  amountDue={amountDue}
                  setAmountDue={setAmountDue}
                  paymentAmount={paymentAmount}
                  setPaymentAmount={setPaymentAmount}
                  week={week}
                  accountId={accountId}
                  paymentType={paymentType}
                  setPaymentType={setPaymentType}
                  promoCode={promoCode}
                  setPromoCode={setPromoCode}
                  groupJoined={groupJoined}
                  ProcessRegistration={ProcessRegistration}
                  validateAndProcessRegistration={validateAndProcessRegistration}
                  setSelectedPage={setSelectedPage}
                  previousPage={CombinationPageOptions.Review}
               />
         }
      </div>
   )
}

export default IndividualRegistration;
